import axios, { InternalAxiosRequestConfig } from 'axios';
import { API_TIMEOUT } from '../../APIConstants';
import { getAGraphBaseUrl, setAGraphHeaders } from '../../utils';
import { AGraphApiSettings } from '../Base';
import { conditionalParam } from './AGraphUtils';
import { AW_INTEGRATIONS_API_URL } from './Constants';

interface Settings extends AGraphApiSettings {
  getConfigurationDirectoryFn?: () => string | undefined;
  getPkgFn?: () => string | undefined;
}

export const awIntegrationsSettings: Settings = {
  getPkgFn: undefined,
  getAladdinApiKey: undefined,
  getConfigurationDirectoryFn: undefined,
  getEnvTypeFn: undefined,
};

export const awIntegrationsApi = axios.create({
  timeout: API_TIMEOUT,
});

awIntegrationsApi.interceptors.request.use((config) => {
  const { getPkgFn, getConfigurationDirectoryFn, getAladdinApiKey, getEnvTypeFn } = awIntegrationsSettings;
  if (!getPkgFn) {
    throw Error('You must define a function for awIntegrationsSettings.getPkgFn before using this API');
  }
  const configurationDirectory = getConfigurationDirectoryFn?.();
  const baseURL = getAGraphBaseUrl(AW_INTEGRATIONS_API_URL);

  const updatedConfig: InternalAxiosRequestConfig = {
    ...config,
    baseURL,
    params: {
      ...config.params,
      pkg: conditionalParam(config.url, 'pkg', getPkgFn()),
      configurationDirectory: conditionalParam(config.url, 'configurationDirectory', configurationDirectory),
    },
  };

  setAGraphHeaders(updatedConfig, getAladdinApiKey?.(), getEnvTypeFn?.());

  return updatedConfig;
});
